// extracted by mini-css-extract-plugin
export var indeterminate = "_63-5";
export var md = "_63-4";
export var semantic = "_63-6";
export var sm = "_63-3";
export var text = "_63-7";
export var toggleInput = "_63-0";
export var toggleSwitch = "_63-1";
export var xs = "_63-2";